import styles from './textAndSubtitle.module.scss';

const TextAndSubtitle = ({ data }) => {
  const { title, subtitle } = data;

  return (
    <section id="sectionTextAndSubtitle">
      <div className={styles.textAndSubtitleWrapper}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </section>
  );
};

export default TextAndSubtitle;
